<script>
    export let model_root;

    let errorMsg = "";
    let successMsg = "";

    let email = "";
    let password = "";

    function login() {
        const data = new FormData();
        data.append("email", email);
        data.append("password", password);

        fetch(model_root + 'admin/user_management/login.php', {
            method: "POST",
            body: data
        })
            .then(response => response.text())
            .then(msg => {
                if(msg === "success") {
                    showSuccessMsg("Sie wurden erfolgreich eingeloggt! Sie werden nun automatisch weitergeleitet.");
                } else {
                    showErrorMsg(msg);
                }
            });

    }

    function showSuccessMsg(msg) {
        errorMsg = "";
        successMsg = msg;
        setTimeout(() => {
            location.reload()
        }, 1800);
    }

    function showErrorMsg(msg) {
        errorMsg = msg;
    }

</script>

<div class="row border-bottom pb-3 mb-3">
    <div class="col-12">
        <a href="https://www.maleck.org" target="_blank">
            <img src="https://www.maleck.org/us/img/logo_v3_test.png" class="w-100 mb-3 maleck_logo">
        </a>
    </div>
    <div class="col">
        <h4 class="header-maleck">Herzlich Willkommen bei <b>FujanaCMS</b>!</h4>
    </div>
</div>

<form class="mb-1"
      on:submit|preventDefault={ () => login() }>

    <p>Bitte melden Sie sich mit Ihrer E-Mail Adresse und Ihrem Passwort an:</p>

    <div class="row">
        <label class="mr-sm-2 mb-1" for="email">E-Mail Adresse:</label>
        <div class="input-group mb-1">
            <div class="input-group-prepend">
                <span class="input-group-text"><i class="fas fa-at"></i>&#8205;</span>
            </div>
            <input type="email" class="form-control" placeholder="E-Mail Adresse" id="email" bind:value={email}>
        </div>
    </div>
    <div class="row">
        <label class="mr-sm-2 mb-1" for="password">Passwort:</label>
        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <span class="input-group-text"><i class="fas fa-key"></i>&#8205;</span>
            </div>
            <input type="password" class="form-control" placeholder="Passwort" id="password" bind:value={password}>
        </div>
    </div>

    {#if errorMsg.length > 0}
        <div class="alert alert-danger" role="alert">
            {errorMsg}
        </div>
    {/if}
    {#if successMsg.length > 0}
        <div class="alert alert-success" role="alert">
            <i class="fas fa-circle-notch fa-spin"></i>
            {successMsg}
        </div>
    {/if}

    <button class="btn btn-primary btn-maleck" type="submit"><i class="fas fa-sign-in-alt"></i> Login</button>
</form>


<style>

    .maleck_logo {
        max-width: 140px;
    }

    .header-maleck {
        color: #2f3e51;
    }

    .btn-maleck {
        background: #2f3e51;
        border-color: #2f3e51;
    }

</style>
